import { render, staticRenderFns } from "./takeCareOfHistory.vue?vue&type=template&id=edd3d3d2"
import script from "./takeCareOfHistory.vue?vue&type=script&lang=js"
export * from "./takeCareOfHistory.vue?vue&type=script&lang=js"
import style0 from "./takeCareOfHistory.vue?vue&type=style&index=0&id=edd3d3d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports